/**
 * This file contains all the features configuration that are available in the application.
 */

export default {
  pricings: {
    description: "Admin and Manufacturer Moderator can set pricing for customers or organizations.",
    enabled: false, // Hide pricing related feature before python 3 release on production
  }
}